export default __webpack_public_path__ + "static/media/email.ed4239ed.svg";